import { z } from 'zod';

const decimalString = z.string().regex(/^-?\d+(\.\d+)?$/, 'invalidDecimal');

export const ScenarioRowSchema = z.object({
  factor: z.string().trim().min(1, 'required'),
  bump_bps: z.string().trim().min(1, 'required'),
});

export type ScenarioRow = z.infer<typeof ScenarioRowSchema>;

export const SimulationFilterSchema = z.object({
  book_id: z.string().trim().optional(),
  asset_class: z.string().trim().optional(),
  counterparty_id: z.string().trim().optional(),
  currency: z.string().trim().optional(),
  deal_ids: z.array(z.string()).optional(),
});

export type SimulationFilter = z.infer<typeof SimulationFilterSchema>;

export const CreateSimulationFormSchema = z.object({
  name: z.string().trim().min(1, 'required'),
  type: z.enum(['eod', 'intraday', 'scenario']),
  market_data_source: z.enum(['closing', 'intraday', 'hypothetical']),
  result_types_csv: z.string().trim().min(1, 'required'),
  eod_date: z.string().optional(),
  simulation_time: z.string().optional(),
  book_id: z.string().optional(),
  asset_class: z.string().optional(),
  counterparty_id: z.string().optional(),
  currency: z.string().optional(),
  scenario_matrix: z.array(ScenarioRowSchema).min(1, 'required'),
});

export type CreateSimulationForm = z.infer<typeof CreateSimulationFormSchema>;

export const SimulationDtoSchema = z.object({
  id: z.string().optional().nullable(),
  name: z.string(),
  type: z.string(),
  market_data_source: z.string(),
  result_types: z.array(z.string()),
  filter: SimulationFilterSchema.nullable().optional(),
  status: z.string().nullable().optional(),
  eod_date: z.string().nullable().optional(),
  simulation_time: z.string().nullable().optional(),
  created_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
});

export type SimulationDto = z.infer<typeof SimulationDtoSchema>;

export const RunSimulationFormSchema = z.object({
  simulation_id: z.string().trim().min(1, 'required'),
});

export type RunSimulationForm = z.infer<typeof RunSimulationFormSchema>;

export const SimulationRunResultSchema = z.object({
  simulation_id: z.string(),
  deals_processed: z.number().int(),
  deals_failed: z.number().int(),
  results_computed: z.number().int(),
  status: z.string(),
});

export type SimulationRunResult = z.infer<typeof SimulationRunResultSchema>;

export const SimulationResultSchema = z.object({
  id: z.string(),
  simulation_id: z.string(),
  deal_id: z.string(),
  result_type: z.string(),
  value: decimalString.nullable().optional(),
  currency: z.string().nullable().optional(),
  value_date: z.string().nullable().optional(),
  breakdown: z.record(z.string(), z.unknown()).nullable().optional(),
  computed_at: z.string(),
});

export type SimulationResult = z.infer<typeof SimulationResultSchema>;
